<div *ngIf="loading" style="text-align: center; padding: 50px;">
  <div class="spinner-border mr-50" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div *ngIf="!loading && this.info.invoices.length > 0 ">
  <div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <div class="m-3" style="text-align: -webkit-center;">


        <!-- Logo -->
        <a target="_blank" class="brand-logo">
          <div style="padding-bottom: 10px;">
            <img src="{{ this.info.locationInfo.locationLogo || 'assets/images/profile/user-uploads/location-00.png'}}" alt="brand-logo" height="40"/>
          </div>
          <h2 class="brand-text ml-1">{{ this.info.locationInfo.locationName }}</h2>
          <h6>Confirm the overdue payment request</h6>

        </a>
        <!-- /Logo -->
        
      </div>  
      <div class="row" style="margin-top: 2rem;" >
        <div class="col-md-12 col-sm-12" >
          <form id="checkout-payment" class=" product-checkout" onsubmit="return false;">
              <div class="card">
                <div class="card-header flex-column align-items-start">
                  <p class="card-text text-muted mt-25">OVERDUE PAYMENT</p>
                </div>
                <div class="card-body">
                  <h6><b id="userPlan0"></b></h6>
                  <hr class="my-2" />
                  <div class="ml-5 row" >
                    <div class="col-12">
                      <p>Hi, <b>{{ this.info.memberInfo.full_name }}</b>, 
                        <br>
                        <b>{{ this.info.locationInfo.locationName }}</b> report that you have {{this.info.invoices.length}} overdue Payment(s):</p>

                        <ul>
                          <li *ngFor="let invoice of this.info.invoices">
                            {{(invoice.dueDate | date: 'dd/MM/yyyy')}} - $ {{invoice.totalAmount.toFixed(2)}}
                          </li>
                        </ul>

                        <br>
                        <h5>Do you want to pay now?</h5>
                    </div>

                    <input type="text" class="form-control ml-50" id="question1" hidden />
                    <input type="text" class="form-control ml-50" id="question2" hidden />
                    <!-- <button id="confirmPayment" (click)="confirmPayment()" hidden></button>   -->

                  </div>
                </div>

                <div class="card-body">
                <button
                  style="width: 150px;"
                  id="confirmBtn"
                  class="btn btn-primary float-right place-order"
                  (click)="confirmPayment()"
                  rippleEffect
                  [disabled]="loadingButton"
                >
                  <span *ngIf="loadingButton" class="spinner-border spinner-border-sm mr-1"></span>
                  Confirm
                </button>
                
                </div>
              </div>


          </form>


    
        </div>  
      </div>
    </div>
  </div>
</div>

<!-- Token Status DONE -->
<div *ngIf="!loading && this.info.invoices.length == 0 ">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-body">
        <div class="m-3" style="text-align: -webkit-center;">
  
  
        <!-- Logo -->
        <a target="_blank" class="brand-logo">
          <div style="padding-bottom: 10px;">
            <img src="{{ this.info.locationInfo.locationLogo || 'assets/images/profile/user-uploads/location-00.png'}}" alt="brand-logo" height="40"/>
          </div>
          <h2 class="brand-text ml-1">{{ this.info.locationInfo.locationName }}</h2>
          <h6>Payment Confirmed</h6>

        </a>
        <!-- /Logo -->
        </div>
      </div>
    </div>
  
</div>
<!-- /Token Status DONE -->




<!-- Footer -->
<div style="margin: 20px;" *ngIf="!loading" >
  <!-- Logo -->
  <div style="text-align: center;">
    <a href="javascript:void(0);" class="brand-logo">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary">{{ coreConfig.app.appName }}</h2>
    </a>
  </div>
  <!-- /Logo -->
  <!-- <p align="center" style="cursor: default; margin-bottom: 16px;">
    <a href="https://smilepass.co/" target="_blank" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity)); text-decoration: none;"><img src="assets/images/icons/facebook.png" width="32" alt="Facebook" style="border: 0; max-width: 100%; line-height: 100%; vertical-align: middle; margin-right: 12px;"></a>
    
    <a href="https://smilepass.co/" target="_blank" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity)); text-decoration: none;"><img src="assets/images/icons/twitter.png" width="32" alt="Twitter" style="border: 0; max-width: 100%; line-height: 100%; vertical-align: middle; margin-right: 12px;"></a>
    
    <a href="https://smilepass.co/" target="_blank" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity)); text-decoration: none;"><img src="assets/images/icons/instagram.png" width="32" alt="Instagram" style="border: 0; max-width: 100%; line-height: 100%; vertical-align: middle; margin-right: 12px;"></a>
  </p> -->
  <p align="center" style="--text-opacity: 1; color: #263238; color: rgba(38, 50, 56, var(--text-opacity));">
    Use of our service and website is subject to our
    <a href="https://smilepass.co/" target="_blank" class="hover-underline" style="--text-opacity: 1; color: #7367f0; color: rgba(115, 103, 240, var(--text-opacity)); text-decoration: none;">Terms of Use</a> and
    <a href="https://smilepass.co/" target="_blank" class="hover-underline" style="--text-opacity: 1; color: #7367f0; color: rgba(115, 103, 240, var(--text-opacity)); text-decoration: none;">Privacy Policy</a>.
  </p>
</div>
<!-- /Footer -->




